import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Role } from '../models';

@Injectable({
  providedIn: 'root'
})
export class RolesService extends BaseService<Role> {

  constructor(httpClient: HttpClient) {
    super('/roles', httpClient);
  }

}